export default __webpack_public_path__ + "static/media/041-care.164fe155.png";